var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchPositive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 96,
    r: 70,
    fill: "#F7F7F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 68L164 68",
    stroke: "#D6D8DD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 118L39 118",
    stroke: "#D6D8DD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156 75L162 75",
    stroke: "#D6D8DD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 125L37 125",
    stroke: "#D6D8DD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171 68H175",
    stroke: "#D6D8DD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.725 68.184C155.088 90.1237 149.756 120.363 127.816 135.725C105.876 151.088 75.637 145.756 60.2746 123.816C44.9123 101.876 50.2443 71.637 72.184 56.2746C94.1237 40.9123 124.363 46.2443 139.725 68.184Z",
    stroke: "#838B98",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.535 73.9193C143.729 91.3353 139.497 115.34 122.081 127.535C104.665 139.729 80.6603 135.497 68.4655 118.081C56.2706 100.665 60.5032 76.6603 77.9193 64.4655C95.3353 52.2706 119.34 56.5032 131.535 73.9193Z",
    fill: "white",
    stroke: "#838B98",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4275 113.206C65.925 99.635 69.2232 80.9302 82.7942 71.4277",
    stroke: "#D6D8DD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M147.231 170.967C146.096 171.761 144.532 171.482 143.742 170.344L122.656 139.945C122.499 139.719 122.554 139.408 122.78 139.251L132.61 132.368C132.837 132.209 133.149 132.265 133.307 132.492L154.404 162.905C155.188 164.036 154.911 165.589 153.784 166.378L147.231 170.967Z",
    stroke: "#838B98",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchPositive);
export default __webpack_public_path__ + "static/media/search_positive.e06265eb6deba69e13893271b6e78eb4.svg";
export { ForwardRef as ReactComponent };